import { CREATE_INSTAGRAM_POST_ANALYTICS_POST_SUCCESS, CREATE_INSTAGRAM_POST_ANALYTICS_POST_ERROR } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instagramPostAnalyticsPost(state=INITIAL_STATE, action) {
  switch(action.type) {
    case CREATE_INSTAGRAM_POST_ANALYTICS_POST_SUCCESS:
       
      return { ...state, data: action.payload.data, errors: null }
    case CREATE_INSTAGRAM_POST_ANALYTICS_POST_ERROR:
      return { ...state, data: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
